// Quantum network — Accenture purple dark mode
export const paramConfig = {
  particles: {
    number: { value: 55, density: { enable: true, value_area: 1000 } },
    color: { value: "#A100FF" },
    opacity: {
      value: 0.35,
      random: true,
      anim: { enable: true, speed: 0.6, opacity_min: 0.05, sync: false },
    },
    size: { value: 2, random: true },
    line_linked: {
      enable: true,
      distance: 160,
      color: "#A100FF",
      opacity: 0.1,
      width: 1,
    },
    move: {
      enable: true,
      speed: 0.6,
      direction: "none",
      random: true,
      out_mode: "out",
    },
  },
  interactivity: {
    detect_on: "canvas",
    events: { onhover: { enable: true, mode: "grab" }, resize: true },
    modes: { grab: { distance: 140, line_linked: { opacity: 0.35 } } },
  },
};

// Light mode particles
export const paramConfigLight = {
  particles: {
    number: { value: 45, density: { enable: true, value_area: 1000 } },
    color: { value: "#7c00cc" },
    opacity: { value: 0.25, random: true },
    size: { value: 1.5, random: true },
    line_linked: {
      enable: true,
      distance: 140,
      color: "#7c00cc",
      opacity: 0.08,
      width: 1,
    },
    move: { enable: true, speed: 0.5, direction: "none", random: true, out_mode: "out" },
  },
  interactivity: {
    detect_on: "canvas",
    events: { onhover: { enable: true, mode: "grab" }, resize: true },
    modes: { grab: { distance: 130, line_linked: { opacity: 0.3 } } },
  },
};

export const sliderSettings = {
  dots: false,
  infinite: false,
  arrows: false,
  speed: 400,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  adaptiveHeight: false,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 768,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};
